/**
 * recharge-variant-bridge.js  v4
 */

(function () {
  'use strict';

  var FORM_INPUT_SELECTOR = 'input[name="id"][data-product-form-variant]';
  var MAIN_PICKER_SELECTOR = 'variant-picker[data-update-url="true"]';
  var VARIANT_JSON_SELECTOR = '[data-selected-variant-json]';
  var CART_ADD_FORM_SELECTOR = 'form[action*="/cart/add"]';

  // Every input[name="id"] node we've seen as the current in-DOM input.
  // Includes detached nodes still held alive by Recharge's closure.
  var seenInputs = new Set();
  var settleTimer = null;

  function trackCurrentInput() {
    var input = document.querySelector(FORM_INPUT_SELECTOR);
    if (input) seenInputs.add(input);
  }

  function getSelectedVariant() {
    var picker = document.querySelector(MAIN_PICKER_SELECTOR);
    var el = picker
      ? picker.querySelector(VARIANT_JSON_SELECTOR)
      : document.querySelector(VARIANT_JSON_SELECTOR);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function mutateAllInputs(newVariantId) {
    var s = String(newVariantId);
    seenInputs.forEach(function (input) {
      if (input.value === s) return; // idempotent
      input.value = s;
      input.setAttribute('value', s);
    });
  }

  function dispatchLegacyEvent(variant) {
    // Forward-compatible: dispatch our v2 CustomEvent for any listener
    // (analytics, third-party widgets) that might rely on it. Recharge
    // does not listen for this.
    var picker = document.querySelector(MAIN_PICKER_SELECTOR);
    var target = picker || document.body;
    target.dispatchEvent(
      new CustomEvent('variant:changed', {
        bubbles: true,
        cancelable: false,
        detail: { variant: variant },
      })
    );
  }

  // ──────────────────────────────────────────────────────────────────
  // (A) Variant change: patch history.replaceState
  // ──────────────────────────────────────────────────────────────────
  var _replaceState = window.history.replaceState.bind(window.history);
  window.history.replaceState = function (state, title, url) {
    var result = _replaceState(state, title, url);

    if (typeof url !== 'string' || !/[?&]variant=\d+/.test(url)) {
      return result;
    }

    trackCurrentInput();

    if (settleTimer) clearTimeout(settleTimer);
    settleTimer = setTimeout(function () {
      settleTimer = null;

      var match = window.location.search.match(/[?&]variant=(\d+)/);
      if (!match) return;
      var newVariantId = match[1];

      var variant = getSelectedVariant();
      if (variant && String(variant.id) !== newVariantId) return;

      trackCurrentInput();
      mutateAllInputs(newVariantId);

      if (variant) dispatchLegacyEvent(variant);
    }, 0);

    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackCurrentInput);
  } else {
    trackCurrentInput();
  }

  // ──────────────────────────────────────────────────────────────────
  // (B) Subscription submit: mirror selling_plan into the submitting form
  // ──────────────────────────────────────────────────────────────────
  //
  // Capture phase: runs before any bubble-phase listener and before the
  // browser's default form-submission handling. Synchronous DOM mutations
  // here are reflected in the submitted FormData.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || typeof form.matches !== 'function') return;
      if (!form.matches(CART_ADD_FORM_SELECTOR)) return;

      // Look for a populated selling_plan in any tracked form other than
      // this one. seenInputs includes detached inputs whose parent forms
      // still hold Recharge-injected state.
      var sellingPlan = '';
      seenInputs.forEach(function (input) {
        var f = input.form;
        if (!f || f === form) return;
        var sp = f.querySelector('input[name="selling_plan"]');
        if (sp && sp.value) sellingPlan = sp.value;
      });
      if (!sellingPlan) return;

      // Mirror into the submitting form. If a selling_plan input already
      // exists (e.g., user subscribed before any variant change), update
      // it; otherwise append a new hidden input.
      var existing = form.querySelector('input[name="selling_plan"]');
      if (existing) {
        if (existing.value !== sellingPlan) existing.value = sellingPlan;
      } else {
        var injected = document.createElement('input');
        injected.type = 'hidden';
        injected.name = 'selling_plan';
        injected.value = sellingPlan;
        form.appendChild(injected);
      }
    },
    true
  );
})();